import { RadioGroup } from '@components/inputs';
import { useEffect, useMemo } from 'react';
import { useAppTranslation } from '@hooks';
import { HitType } from '@pages/types';
import { Button, colors, Tag, useDisclosure } from 'common-components';

import { DataLabel, DataRow, DataValue } from './SidebarRows';

import { store } from '@/store';

export type ReviewTaskLineHitPropsType = {
  hit?: HitType
};
const ReviewHitTask = function ({ hit }: ReviewTaskLineHitPropsType) {
  const { translate } = useAppTranslation();

  const { open, close, isOpen } = useDisclosure();

  const updateMarkHitAction = store.use.updateMarkHitAction().call;

  useEffect(() => {
    hit?.mark ? close() : open();
  }, [hit?.idHit]);

  const onReviewUpdate = (mark: number) => {
    updateMarkHitAction({
      mark,
      idHit: hit.idHit,
    });
  };

  const lastReview = useMemo(() => {
    return hit?.hitReviews?.[hit.hitReviews?.length - 1];
  }, [hit?.idHit, hit?.hitReviews]);

  return (
    <>
      {isOpen && <RadioGroup onChange={(val) => typeof val === 'number' && onReviewUpdate(val)} />}
      <DataRow>
        <DataLabel>{translate('project.tasklineOverview.sidebar.review.rate')}</DataLabel>
        <Tag style={{ background: colors.success50, color: colors.success700, fontWeight: 500 }}>
          {lastReview?.mark}
        </Tag>
      </DataRow>
      <DataRow>
        <DataLabel>{translate('project.tasklineOverview.sidebar.review.reviewer')}</DataLabel>
        <DataValue>{lastReview?.idReviewer}</DataValue>
      </DataRow>
      <DataRow>
        <DataLabel>{translate('project.tasklineOverview.sidebar.review.reviewDate')}</DataLabel>
        <DataValue>{lastReview?.reviewDate}</DataValue>
      </DataRow>

      <Button onClick={open} size={'sm'} style={{ alignSelf: 'flex-start' }}>
        {translate('common.buttons.edit')}
      </Button>
    </>
  );
};
export default ReviewHitTask;
